import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators'
import { LoadingService } from '../services/loading.service';


@Injectable({ providedIn: 'root' })
export class HttpRequestInterceptor implements HttpInterceptor {

  constructor(
     private loaderService: LoadingService ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    
    this.loaderService.setLoading(true, req.url);

    return next.handle(req).pipe(   
      finalize(() => this.loaderService.setLoading(false, req.url))
    );
  } 
}
